import React from 'react';
import PropTypes from 'prop-types';
import CheckIcon from '@mui/icons-material/Check';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import numeral from 'numeral';

import { useTheme } from 'contexts/ThemeContext';

import { Text, Tooltip } from 'components/DataDisplay';
import { Container, Item } from 'components/Layout';

import { CreaRow } from './CreaRow';
import { InlineIdEditor } from './InlineIdEditor';

export const AudienceGroup = ({ audience }) => {
  const { themeColors } = useTheme();
  const { designSystem } = themeColors;
  const { name, subtotal, creas, externalId, onSaveId } = audience;
  const { criteria } = audience;
  const creaCountLabel = `${creas.length} créa${
    creas.length > 1 ? 's' : ''
  } · ${numeral(subtotal).format('0,0 $')}`;

  return (
    <Container
      flex
      style={{
        width: '100%',
        flexDirection: 'column',
        alignItems: 'stretch',
        border: `1px solid ${designSystem.lineSoft}`,
        borderRadius: '9px',
        overflow: 'hidden'
      }}
    >
      <Item
        flex
        style={{
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '9px',
          padding: '8px 11px',
          backgroundColor: designSystem.bgSoft
        }}
      >
        <Item
          flex
          style={{
            alignItems: 'center',
            gap: '9px',
            justifyContent: 'flex-start'
          }}
        >
          <Text
            component="span"
            fontSize="9.5px"
            fontWeight={700}
            style={{
              letterSpacing: '0.4px',
              color: designSystem.muted,
              backgroundColor: themeColors.keep_light,
              border: `1px solid ${designSystem.line}`,
              borderRadius: '5px',
              padding: '2px 7px',
              whiteSpace: 'nowrap'
            }}
          >
            AUDIENCE
          </Text>
          <Text
            component="span"
            fontSize="12.5px"
            fontWeight={700}
            style={{ color: designSystem.ink }}
          >
            {name}
          </Text>
          <InlineIdEditor value={externalId} onSave={onSaveId} />
          {criteria.length > 0 && (
            <Tooltip
              title={
                <Item
                  flex
                  style={{
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: '3px'
                  }}
                >
                  <Text
                    component="span"
                    color="inherit"
                    fontSize="10px"
                    fontWeight={700}
                    style={{
                      letterSpacing: '0.5px',
                      textTransform: 'uppercase',
                      opacity: 0.65,
                      marginBottom: '2px'
                    }}
                  >
                    Critères de l&apos;audience
                  </Text>
                  {criteria.map(criterion => (
                    <Item
                      flex
                      key={criterion}
                      style={{
                        alignItems: 'center',
                        gap: '7px',
                        justifyContent: 'flex-start'
                      }}
                    >
                      <CheckIcon style={{ fontSize: '13px' }} />
                      <Text component="span" color="inherit" fontSize="11.5px">
                        {criterion}
                      </Text>
                    </Item>
                  ))}
                </Item>
              }
            >
              <InfoOutlinedIcon
                style={{
                  fontSize: '15px',
                  color: designSystem.faint,
                  cursor: 'pointer'
                }}
              />
            </Tooltip>
          )}
        </Item>
        <Text
          component="span"
          fontSize="11.5px"
          style={{ color: designSystem.muted, whiteSpace: 'nowrap' }}
        >
          {creaCountLabel}
        </Text>
      </Item>
      <Item
        flex
        style={{
          flexDirection: 'column',
          alignItems: 'stretch',
          padding: '3px 5px 5px'
        }}
      >
        {creas.map(crea => (
          <CreaRow crea={crea} key={crea.id} />
        ))}
      </Item>
    </Container>
  );
};

AudienceGroup.propTypes = {
  audience: PropTypes.shape().isRequired
};

export default AudienceGroup;
